<div>
  <div class="summary-group">
    <div class="summary-title">{{'tasks.saving_agreement_detail' | translate  | uppercase}}</div>
  </div>
  <div class="font-13" style="overflow-y: auto; overflow-x: hidden;">
    @if (savingAgreementApproval) {
      <div>
        <div class="field grid row hrBottom">
          <div class="col-12">
            <div class="row">
              <div class="col padding-item">
                            <a [attr.href]="isSavingApproval? '/user/customers/view/'+savingAgreementApproval.customerSpecificOptions[0].customerId+'?agrNum='+savingAgreementApproval.savingAgreementNumber : null">
                                <span class="title-label" pTooltip="Click and go to Saving Agreements page" tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>savings.number</span>:</span>
                            
                                <span class="value-label" pTooltip="Click and go to Saving Agreements page" tooltipStyleClass="tooltip-class" tooltipPosition="left">{{savingAgreementApproval.agreementNumber}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                        </div>
                    </div>

                </div>
            </div>
            <div class="field grid row hrBottom font-13">
                <div class="col-12">
                    @for (item of savingAgreementApproval.customerSpecificOptions; track item; let i = $index) {
<div style="width: 100%">
                        <div class="row">
                            <div class="col">
                                <a [attr.href]="isSavingApproval? '/user/customers/view/'+savingAgreementApproval.customerSpecificOptions[0].customerId : null">
                                    <span class="title-label" pTooltip="Click and go to Customers page" tooltipStyleClass="tooltip-class" tooltipPosition="left" translate>customer_mngt.customer_id<span>:</span></span>
                                    <span class="value-label" pTooltip="Click and go to Customers page" tooltipStyleClass="tooltip-class" tooltipPosition="left">{{savingAgreementApproval.customerSpecificOptions[0].customerNumber}}</span>
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span class="sub-title-label" translate>common.name<span>:</span></span> 
                                <span class="value-label">{{savingAgreementApproval.customerSpecificOptions[0].firstName + " " + savingAgreementApproval.customerSpecificOptions[0].lastName}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span class="sub-title-label" translate>accounts.correspondent<span>:</span></span> 
                                <span class="value-label">{{savingAgreementApproval?.correspondentAccountNumber || 'N/A'}}</span>
                            </div>
                        </div>
                    </div>
}
                </div>
            </div>

            <div class="hrBottom">
                @if (savingAgreementApproval.linkedAccount) {
<div class="field grid row">
                    <div class="row">
                        <div class="col">
                            <span class="title-label" translate>linked_accounts.title</span>
                        </div>

                    </div>
    
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>accounts.interest_acc<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.interestPaymentAccountNumber || 'N/A'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>savings.interest_expense_acc<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.linkedAccount.interestExpenseAccountNumber || 'N/A'}}</span>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>savings.tax_acc<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.linkedAccount.taxAccountNumber || 'N/A'}}</span>
                        </div>
                    </div>
    
                </div>
}
            </div>

            @if (savingAgreementApproval.savingAgreementNote) {
<div class="hrBottom">
                <div class="field grid row">
                    <div class="col">
                        <span class="title-label">{{'common.notes' | translate}}</span>
                    </div>
                </div>
                <div class="field grid row">
                    @for (note of savingAgreementApproval.savingAgreementNote; track note) {
<div>
                        <div class="row">
                            <div class="col padding-item">
                                <span class="sub-title-label">{{note.parentName ? note.parentName : note.name}}{{note.parentName ? ':' : ''}}</span>
                                <span class="value-label"> {{note.parentName ? note.name : ''}}</span>                             
                            </div>
                        </div>
                    </div>
}    
                </div>
            </div>
}

            <div class="hrBottom">
                <div class="field grid row">
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>common.branch<span>:</span></span> 
                            <span class="value-label">{{getBranchName(savingAgreementApproval.branchId)  || '—'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>common.start_date<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.startDate  || '—'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>savings.tax_rate<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.incomeTaxRate  || '—'}}%</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>savings.interest_payment_period<span>:</span></span> 
                            <span class="value-label">{{formatTextCapitalize(savingAgreementApproval.interestPaymentPeriod)  || '—'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>savings.interest_calc_method<span>:</span></span> 
                            <span class="value-label">{{formatTextCapitalize(savingAgreementApproval.interestCalculationOption)  || '—'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>common.description<span>:</span></span> 
                            <span class="value-label">{{savingAgreementApproval.savingAgreementTemplateDescription  || '—'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
}        
    </div>
</div>